/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Blocked_CustomersInputs */

const en_nav_blocked_customers = /** @type {(inputs: Nav_Blocked_CustomersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocked customers`)
};

/**
* | output |
* | --- |
* | "Blocked customers" |
*
* @param {Nav_Blocked_CustomersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_blocked_customers = /** @type {((inputs?: Nav_Blocked_CustomersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Blocked_CustomersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_blocked_customers(inputs)
});